import React from "react";
import { Close } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";

interface PopoutHeaderProps {
  onClose: () => void;
}

const PopoutHeader: React.FC<PopoutHeaderProps> = ({ onClose }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography variant="h6" fontWeight={700}>
        Preferencing options
      </Typography>
      <IconButton size="small" onClick={onClose} aria-label="Close">
        <Close fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default PopoutHeader;
